/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import {
    ContentDisplayBox,
    DropDownSelect,
    Heading1,
    Paragraph,
} from '@motili/ui';
import { ReactElement } from 'react';
import { styled } from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../../../common/redux/hooks';
import { setServiceArea } from '../../../../common/redux/ducks/contractorRegistrationForm';

type ServiceAreaDropdownOption = { value: string; label: string };

export default function ServiceArea(): ReactElement {
    const dispatch = useAppDispatch();
    const serviceArea = useAppSelector(
        ({ contractorRegistration }) =>
            contractorRegistration.contractor.serviceArea
    );
    const companyInfo = useAppSelector(
        ({ contractorRegistration }) =>
            contractorRegistration.contractor.companyInfo
    );
    const {
        companyAddress: { address1, address2, city, state, zip },
    } = companyInfo;

    const formatAddress = () => {
        if (address2) {
            return (
                <Paragraph>{`${address1}, ${address2}, ${city}, ${state} ${zip}`}</Paragraph>
            );
        } else {
            return (
                <Paragraph>{`${address1}, ${city}, ${state} ${zip}`}</Paragraph>
            );
        }
    };

    const handleDropDownChange = (data: ServiceAreaDropdownOption) => {
        dispatch(setServiceArea(data.value));
    };

    return (
        <>
            <Heading1>Service Area</Heading1>
            <Paragraph>
                Based on the Company Address you entered (Shown below) please
                let us know the area you and your team are able to service. You
                can omit or include additional zip codes later if necessary.
            </Paragraph>
            <StyledContentDisplayBox>
                <b>Company Address:</b>
                {formatAddress()}
            </StyledContentDisplayBox>
            <br />
            <DropDownSelect
                required
                value={{ value: serviceArea, label: serviceArea }}
                name={'serviceArea'}
                closeMenuOnSelect={false}
                onChange={option =>
                    handleDropDownChange(option as ServiceAreaDropdownOption)
                }
                label='SELECT YOUR SERVICE RADIUS'
                options={[
                    { value: '20 miles', label: '20 miles' },
                    { value: '50 miles', label: '50 miles' },
                    { value: '100 miles', label: '100 miles' },
                    { value: '200 miles', label: '200 miles' },
                ]}
            />
        </>
    );
}

const StyledContentDisplayBox = styled(ContentDisplayBox)`
    margin-top: 20px;
    padding: 15px 0 0 15px;
    background-color: #edf8fc;
    border: 1px solid #05a6e6;
    border-radius: 4px;
`;
